const spacer = {
    Spacer: {
        baseStyle: ({spaceDesktop, spaceTablet, spaceMobile, backgroundColor}) => ({
            container: {
                w: '100%',
                h: {base: spaceMobile, md: spaceTablet, xl: spaceDesktop},
                backgroundColor: backgroundColor || 'unset',
            },
        }),
    },
}

export default spacer
